import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { ComponentSettingKey } from '@/shared/builder'

import { CompCardWrapperCore } from '../core/card/wrapper'
import { CompCard } from './CompCard'
import { CompCardItem } from './CompCardItem'

/**
 * CompCardWrapper
 */
function CompCardWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const { menus } = useAppBuilderContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  // trailing elements
  const trailingHeaderMenuId = compContext.settings[ComponentSettingKey.CardDataTrailingHeaderMenu]
  const trailingHeaderMenu = menus.find((m) => m.id === trailingHeaderMenuId)
  const trailingMenuId = compContext.settings[ComponentSettingKey.CardDataTrailingMenu]
  const trailingMenu = menus.find((m) => m.id === trailingMenuId)

  // tableData
  const { dbClient, language, userSpecific, tablesMap } = useDbClientContext()
  const tableId = compContext.settings[ComponentSettingKey.CardDataSource]
  const table = tableId ? tablesMap.get(tableId as string) : undefined

  if (!table || !dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompCardWrapperCore
      infos={infosProps}
      action={actionContext}
      tableData={{ dbTable: table, dbClient, tableId, language, userSpecific }}
    >
      {(cardProps) => (
        <CompCard {...cardProps} action={actionContext}>
          {(itemProps) => (
            <CompCardItem
              {...itemProps}
              component={compContext.component}
              action={actionContext}
              containerClient={compContext.containerClient}
              trailingHeaderMenu={trailingHeaderMenu}
              trailingMenu={trailingMenu}
            />
          )}
        </CompCard>
      )}
    </CompCardWrapperCore>
  )
}

export default CompCardWrapper
